import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    container: {
        margin: theme.spacing(3),
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: theme.spacing(3),
        flexWrap: 'wrap',
        gap: theme.spacing(2),
    },
    title: {
        fontWeight: 'bold',
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1),
    },
    subtitle: {
        color: theme.palette.text.secondary,
    },
    addButton: {
        height: '40px',
        minWidth: '140px',
    },
    filters: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(3),
        flexWrap: 'wrap',
    },
    searchField: {
        minWidth: '300px',
        '& .MuiOutlinedInput-root': {
            height: '40px',
        },
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(6),
        textAlign: 'center',
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.divider}`,
    },
    emptyTitle: {
        marginBottom: theme.spacing(2),
        color: theme.palette.text.primary,
    },
    emptyDescription: {
        marginBottom: theme.spacing(3),
        color: theme.palette.text.secondary,
        maxWidth: '400px',
    },
    emptyButton: {
        height: '40px',
        minWidth: '140px',
    },
    tableContainer: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
    },
    statusChip: {
        height: '24px',
        fontSize: '0.75rem',
    },
    actionButton: {
        minWidth: 'auto',
        padding: theme.spacing(0.5),
    },
    formContainer: {
        padding: theme.spacing(2),
    },
    formField: {
        marginBottom: theme.spacing(2),
    },
    formActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(2),
        marginTop: theme.spacing(3),
    },
    helpText: {
        fontSize: '0.75rem',
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.5),
    },
    ageRangeContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        alignItems: 'flex-start',
    },
    ageField: {
        flex: 1,
    },
}));
